import { useEffect } from "react";
import { useAuth } from "../../utils/useAuth";
import { Spin, notification } from "antd";
import { Switch, Route, Redirect } from "react-router-dom";
import LayoutSistemaHeader from "./LayoutSistemaHeader";
import * as SHARED from "../../utils/shared";
import { isAsistenciaEnabled } from "../../api/auxiliar";
import { logout } from "../../api/auth";

function LayoutSistema({ routes }) {
  const { usuario, isAdmin, isLoading } = useAuth();

  const fetchDataToPage = async () => {
    isAsistenciaEnabled().then((res) => {
      if (!res.payload.asistenciaEnabled) {
        notification.error({ message: "Marcar asistencia no está habilitado" });
        logout();
        window.location.href = "/";
      }
    });
  };

  useEffect(() => {
    fetchDataToPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return <Spin tip="Cargando" className="w-full py-60" />;
  }

  if (!usuario) return <Redirect to="/login" />;

  if (isAdmin) return <Redirect to="/app" />;

  return (
    <div className="flex flex-col w-full min-h-screen items-center justify-between">
      <LayoutSistemaHeader user={usuario} />
      <main className="mb-auto w-full md:flex md:content-between">
        <aside className="w-full px-6">
          <LoadRoutes routes={routes} user={usuario} />
        </aside>
      </main>
      <footer className="py-8">
        <p className="text-center font-semibold text-xs text-gray-400">
          {SHARED.TITLE_SISTEMA_SHORT}
        </p>
      </footer>
    </div>
  );
}
export default LayoutSistema;

/**
 * Carga las rutas definidas en el archivo de rutas.
 * @param {Array} routes
 */
function LoadRoutes(props) {
  const { routes, user } = props;
  return (
    <Switch>
      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          component={(props) => <route.component {...props} user={user} />}
        />
      ))}
    </Switch>
  );
}
